// extracted by mini-css-extract-plugin
module.exports = {"Page":"ManagerInternalAccount_Page__2W7B3"};